<template>
  <div class="login-container">
    <!-- 背景装饰 -->
    <div class="title">
      <img :src="require('../../assets/logo1.png')" alt="网站logo" class="logo" />
      <h1 class="main-title">{{$platformName }}</h1>
    </div>
    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- 系统标题 -->
      <div class="system-title">
        <h1>数据管理系统</h1>
        <p>管理员登录</p>
      </div>

      <!-- 登录表单 -->
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form"
        @keyup.enter.native="handleLogin">
        <!-- 用户名输入 -->
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" type="username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <!-- 密码输入 -->
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
        <!-- 登录按钮 -->
        <el-form-item>
          <el-button type="primary" class="login-button" @click="handleLogin" :loading="loginLoading">
            <span v-if="!loginLoading">登录</span>
            <span v-else>登录中...</span>
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 版权信息 -->
      <div class="copyright">
        © 2025 本溪高新区科技成果转化综合服务平台 版权所有
      </div>
    </div>


  </div>
</template>

<script>
import request from '../../utils/request'

export default {
  name: 'Login',
  data() {
    // 用户名验证规则
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'));
      }
      if (value.length < 3) {
        return callback(new Error('用户名长度不能少于3位'));
      }
      callback();
    };

    // 密码验证规则
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      if (value.length < 6) {
        return callback(new Error('密码长度不能少于6位'));
      }
      callback();
    };

    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      // 登录表单数据
      loginForm: {
        username: '',
        password: ''
      },
      // 记住密码
      rememberMe: false,
      // 输入框焦点状态
      usernameFocus: false,
      passwordFocus: false,
      // 登录加载状态
      loginLoading: false,
      // 忘记密码对话框显示状态
      forgotDialogVisible: false,
      // 登录表单验证规则
      loginRules: {
        username: [{ validator: validateUsername, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }]
      },
    };
  },
  created() {
    // 检查是否有记住的密码
    this.checkRememberedPassword();
  },
  methods: {
    //用户名密码验证
    checkUsernameAndPassword() {
      if (this.loginForm.username === 'admin' && this.loginForm.password === '123456') { return true; }
      return false;
    },
    handleLoginError() {
      this.$message.error('用户名或密码错误，请重新输入');
    },
    // 检查是否有记住的密码
    checkRememberedPassword() {
      const rememberedUser = localStorage.getItem('rememberedUser');
      if (rememberedUser) {
        const userInfo = JSON.parse(rememberedUser);
        this.loginForm.username = userInfo.username;
        this.loginForm.password = userInfo.password;
        this.rememberMe = true;
      }
    },

    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loginLoading = true;

          request.post('/api/login', {
            name: this.loginForm.username,
            password: this.loginForm.password
          }).then(res => {
            this.loginLoading = false;
            if (res.code === 200 && res.token) {
              localStorage.setItem('token', res.token);
              localStorage.setItem('currentUser', JSON.stringify({
                name: this.loginForm.username,
                id: 'ADM001'
              }));
              this.$message.success(res.message || '登录成功');
              this.$router.push('/manager/home');
            } else {
              this.$message.error(res.message || '登录失败');
            }
          }).catch(error => {
            this.loginLoading = false;
            console.error('登录请求失败:', error);
            this.$message.error('登录失败，请稍后重试');
          });
        }
      });
    },


  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  flex-direction: column;

}

.logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image:
    radial-gradient(circle at 20% 30%, rgba(64, 158, 255, 0.1) 0%, transparent 40%),
    radial-gradient(circle at 80% 70%, rgba(64, 158, 255, 0.1) 0%, transparent 40%);
  z-index: 1;
}

.main-title {
  font-size: 3rem;
  margin: 40px;
}

/* 登录卡片 */
.login-card {
  width: 100%;
  max-width: 400px;
  padding: 40px 30px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
}

/* 系统标题 */
.system-title {
  text-align: center;
  margin-bottom: 30px;
}

.system-title h1 {
  font-size: 24px;
  color: #1f2d3d;
  margin-bottom: 8px;
  font-weight: 600;
}

.system-title p {
  font-size: 14px;
  color: #8392a5;
}

/* 登录表单 */
.login-form {
  margin-top: 20px;
}

/* 输入框样式 */
::v-deep .el-input {
  height: 44px;
}

:deep(.el-input__inner) {
  height: 44px;
  border-radius: 6px;
  transition: all 0.3s ease;
  box-shadow: none;
  background-color: transparent !important;

}

.title {
  display: flex;
  align-items: center;
}




/* 登录按钮 */
.login-button {
  width: 100%;
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
  background-color: #409eff;
  border-color: #409eff;
  transition: all 0.3s ease;
}

.login-button:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* 版权信息 */
.copyright {
  text-align: center;
  margin-top: 30px;
  font-size: 12px;
  color: #8392a5;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .login-card {
    width: 90%;
    padding: 30px 20px;
  }
}
</style>
